import { userSchema } from "../auth/types.js";
import { ticketSchema } from "../tickets/types.js";
import { candidateMetadataSchema } from "../candidates/types.js";
import { z } from "zod";
export const contactMetadataSchema = z
    .object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    GSI2_PK: z.string(),
    GSI2_SK: z.string(),
    addressPostalCode: z.string().optional().or(z.null()),
    id: z.string(),
    firstName: z.string(),
    lastName: z.string().optional(),
    mobile: z.string().optional(),
    emailAddress: z.string().optional(),
    emailOptIn: z.boolean().optional(),
    smsOptIn: z.boolean().optional(),
    title: z.string().optional(),
})
    .catchall(z.any());
export const contactSchema = contactMetadataSchema
    .extend({
    actions: z.array(z.record(z.any())),
    candidate: candidateMetadataSchema.optional(),
    tags: z.array(z.record(z.any())),
    title: z.string().optional(),
    user: userSchema.optional(),
    tickets: z.array(ticketSchema),
})
    .catchall(z.any());
export const candidateContactSchema = contactMetadataSchema.merge(z.object({
    user: userSchema.optional(),
}));
// export type Contact = {
//   GSI1_PK: string;
//   GSI1_SK: string;
//   GSI2_PK: string;
//   GSI2_SK: string;
//   PK: string;
//   SK: string;
//   id: string;
//   firstName: string;
//   lastName: string;
//   mobile: string;
//   emailAddress: string;
//   emailOptIn: boolean;
//   smsOptIn: boolean;
//   title?: string;
//   user?: User;
//   tickets: Array<Ticket>;
// };
//# sourceMappingURL=types.js.map